class CardProductGroupSwatches extends HTMLElement {
  constructor() {
    super();
    this.group = this.dataset.group
    this.productHandle = this.dataset.productHandle
    this.items = null
    this.fetchItems()
  }

  async fetchItems () {
    this.items = await fetch(`/collections/all/${this.group}?view=ajax`).then(res => res.json())
    if (!this.items || this.items.length == 1) return

    this.items.sort((x,y) => { return x.handle === this.productHandle ? -1 : y.handle === this.productHandle ? 1 : 0; })

    let optionsHtml = this.items.slice(0, 5).map((item, index) => {
      return `<a
        href="${item.url}"
        style="--swatch-background-image: url('${item.swatch_url}');"
        class="product-form__color-swatch js-product-form__color-swatch ${index == 4 ? 'product-form__color-swatch--desktop' : ''} ${this.productHandle === item.handle ? 'active' : ''}"
        title="${item.swatch_value}"
      ><span class="visibility-hidden">${item.swatch_value}</span></a>`
    }).join('')

    if (this.items.length > 5){
      optionsHtml += `<span class="product-form__color-total product-form__color-total--desktop">+ ${ this.items.length - 5} more</span>`
      optionsHtml += `<span class="product-form__color-total product-form__color-total--mobile">+ ${ this.items.length - 4} more</span>`
    }

    this.innerHTML = optionsHtml;
  }
}

customElements.define('card-product-group-swatches', CardProductGroupSwatches);
